import React from 'react';
type SectionHeadingProps = {
  id: string;
  children: React.ReactNode;
  className?: string;
};
export function SectionHeading({
  id,
  children,
  className = ''
}: SectionHeadingProps) {
  return <div className={`text-center ${className}`} data-id="element-208" data-mp="vytka0m3k6hk">
      <h2 id={id} className="mx-auto max-w-3xl text-balance text-3xl font-extrabold uppercase leading-tight tracking-tight text-stone-50 sm:text-4xl" data-id="element-209" data-mp="vxjo5gyt18dk">
        {children}
      </h2>
      <span className="mx-auto mt-4 flex w-fit items-center gap-1" aria-hidden="true" data-id="element-210" data-mp="n099rmqox34f">
        <span className="h-1 w-10 rounded-full bg-slate-500" data-id="element-211" data-mp="i6wvo6jn0epx" />
        <span className="h-1 w-3 rounded-full bg-yellow-400" data-id="element-212" data-mp="d8lo62gtegav" />
      </span>
    </div>;
}